import {inject, injectable} from 'inversify';

import type {EditionApiModel} from '../../../../api/program';
import type {IApiDataMapper} from '../../../ports/types';

import {PaymentPlanMapperJrpc} from '../../common/PaymentPlan/mappers/PaymentPlan.mapper.jrpc';
import {ProgramDurationFactory} from '../../common/ProgramDuration/ProgramDuration.factory';
import {EditionFactory} from '../Edition.factory';
import {EditionModel} from '../Edition.model';
import {EditionExpandJrpc} from './Edition.expand.jrpc';

@injectable()
export class EditionMapperJrpc
  implements
    IApiDataMapper<EditionMapperJrpc.ApiData, EditionModel.Props, EditionModel>
{
  constructor(
    @inject(EditionFactory)
    private readonly factory: EditionFactory,
    @inject(EditionExpandJrpc)
    public readonly expand: EditionExpandJrpc,
    @inject(ProgramDurationFactory)
    private readonly programDurationFactory: ProgramDurationFactory,
    @inject(PaymentPlanMapperJrpc)
    private readonly paymentPlanMapper: PaymentPlanMapperJrpc,
  ) {}

  mapDataToModel(apiData: EditionMapperJrpc.ApiData): EditionModel {
    return this.factory.create(this.mapDataToProps(apiData));
  }

  mapDataToProps(apiData: EditionMapperJrpc.ApiData): EditionModel.Props {
    return {
      duration: this.programDurationFactory.create(apiData.duration),
      id: apiData._id,
      isAutoRestarting: apiData.is_autorestarting,
      paymentPlan: apiData.payment_plan
        ? this.paymentPlanMapper.mapDataToModel(apiData.payment_plan)
        : null,
      programId: apiData.program_id,
      status: apiData.status,
      title: apiData.title,
    };
  }
}

export namespace EditionMapperJrpc {
  export type ApiData = EditionApiModel;

  export type ExpandedApiData = ApiData & EditionExpandJrpc.ExpandedFields;
}
